// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FOS_pageWrap__KXJGc {
  padding: 4px 4px 32px;
}

.FOS_desktopTable__-LA\\+A {
  display: block;
}

.FOS_mobileList__M0J4N {
  display: none;
}

@media (max-width: 767px) {
  .FOS_desktopTable__-LA\\+A {
    display: none;
  }
  .FOS_mobileList__M0J4N {
    display: block;
  }
}

/* =========================================================
   Toolbar
   ========================================================= */
.FOS_toolbarRow__eFOJn {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  padding: 16px 24px;
  border-bottom: 1px solid #EEF0F6;
}

.FOS_searchInput__iaMSm {
  padding: 9px 14px;
  border-radius: 10px;
  border: 1px solid #E5E7EB;
  font-size: 13.5px;
  background: #ffffff;
  min-width: 240px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.FOS_searchInput__iaMSm:focus {
  outline: none;
  border-color: #4c2fb3;
  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);
}

.FOS_filterSelect__H0xOF {
  padding: 9px 14px;
  border-radius: 10px;
  border: 1px solid #E5E7EB;
  font-size: 13.5px;
  background: #ffffff;
  min-width: 160px;
  flex-shrink: 0;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.FOS_filterSelect__H0xOF:focus {
  outline: none;
  border-color: #4c2fb3;
  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);
}

.FOS_spacer__sfD3d {
  flex: 1 1;
}

/* =========================================================
   Status pills
   ========================================================= */
.FOS_pillBase__dO9fy {
  display: inline-flex;
  align-items: center;
  padding: 3px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}
.FOS_pillGreen__oJFhU { background: #E9F9EF; color: #16A34A; }
.FOS_pillRed__agyOh { background: #FDEDED; color: #DC2626; }

.FOS_referralChip__WR198 {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #F5F3FE;
  color: #4c2fb3;
  font-weight: 700;
  font-size: 12px;
  padding: 4px 12px;
  border-radius: 20px;
  font-family: 'Courier New', monospace;
  cursor: pointer;
  border: none;
  transition: background 0.15s ease;
}
.FOS_referralChip__WR198:hover {
  background: #E7DEFB;
}

.FOS_actionCell__7LTrQ {
  display: flex;
  align-items: center;
  gap: 8px;
}

.FOS_sellersChip__G\\+CwX {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #EEFBF3;
  color: #16A34A;
  font-weight: 700;
  font-size: 12px;
  padding: 4px 12px;
  border-radius: 20px;
  cursor: pointer;
  border: none;
  white-space: nowrap;
  transition: background 0.15s ease;
}
.FOS_sellersChip__G\\+CwX:hover {
  background: #DDF5E6;
}

/* =========================================================
   Assigned sellers modal
   ========================================================= */
.FOS_modalOverlay__xsCgT {
  position: fixed;
  inset: 0;
  background: rgba(17, 12, 46, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 16px;
}

.FOS_modalBox__iruw5 {
  background: #ffffff;
  border-radius: 16px;
  width: 100%;
  max-width: 460px;
  max-height: 70vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(17, 12, 46, 0.25);
}

.FOS_modalHeader__6z4zf {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #EEF0F6;
  font-weight: 700;
  font-size: 14.5px;
  color: #1F2430;
  font-family: 'Sora', 'Inter', sans-serif;
}

.FOS_modalBody__4SBqT {
  padding: 12px 20px 20px;
  overflow-y: auto;
}

.FOS_sellerRow__MoVyo {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 10px 0;
  border-bottom: 1px solid #F3F4F6;
}
.FOS_sellerRow__MoVyo:last-child {
  border-bottom: none;
}

.FOS_sellerName__ZYHvN {
  font-weight: 700;
  font-size: 13.5px;
  color: #1F2430;
}

.FOS_sellerProviderId__AX1vj {
  font-size: 12px;
  color: #9CA3AF;
  font-family: 'Courier New', monospace;
}

.FOS_emptyState__7V5zN {
  text-align: center;
  color: #9CA3AF;
  font-size: 13.5px;
  padding: 40px 0;
}

/* =========================================================
   Mobile card list
   ========================================================= */
.FOS_mobileCard__Zf9Vn {
  border: 1px solid #EEF0F6;
  border-radius: 14px;
  background: #ffffff;
  padding: 16px;
  margin-bottom: 12px;
}

.FOS_mobileRow__t3Ou6 {
  display: flex;
  gap: 12px;
  padding: 4px 0;
  font-size: 13px;
}

.FOS_mobileLabel__Q2ehC {
  min-width: 100px;
  flex-shrink: 0;
  color: #6B7280;
  font-weight: 600;
}

.FOS_mobileValue__8\\+ePj {
  color: #1F2430;
}

.FOS_mobileActionRow__cycPh {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
  flex-wrap: wrap;
}

/* =========================================================
   Add / Edit form
   ========================================================= */
.FOS_referralBox__7L7hj {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  background: #F5F3FE;
  border: 1px solid #E7DEFB;
  border-radius: 10px;
  padding: 10px 16px;
}

.FOS_referralCode__jpCXM {
  font-family: 'Courier New', monospace;
  font-weight: 700;
  color: #4c2fb3;
  font-size: 14px;
}

.FOS_regenerateBtn__gd8W\\+ {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #ffffff;
  color: #4c2fb3;
  border: 1px solid #C9BCF2;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 700;
  padding: 6px 12px;
  cursor: pointer;
  transition: background 0.15s ease;
}
.FOS_regenerateBtn__gd8W\\+:hover {
  background: #F5F3FE;
}
`, "",{"version":3,"sources":["webpack://./src/pages/FOS/FOS.module.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;AACF;;AAEA;;8DAE8D;AAC9D;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,0DAA0D;AAC5D;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,0DAA0D;AAC5D;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,SAAO;AACT;;AAEA;;8DAE8D;AAC9D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA,wBAAa,mBAAmB,EAAE,cAAc,EAAE;AAClD,sBAAW,mBAAmB,EAAE,cAAc,EAAE;;AAEhD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;EACrC,eAAe;EACf,YAAY;EACZ,iCAAiC;AACnC;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,iCAAiC;AACnC;AACA;EACE,mBAAmB;AACrB;;AAEA;;8DAE8D;AAC9D;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;8DAE8D;AAC9D;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;8DAE8D;AAC9D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,mBAAmB;AACrB","sourcesContent":[".pageWrap {\n  padding: 4px 4px 32px;\n}\n\n.desktopTable {\n  display: block;\n}\n\n.mobileList {\n  display: none;\n}\n\n@media (max-width: 767px) {\n  .desktopTable {\n    display: none;\n  }\n  .mobileList {\n    display: block;\n  }\n}\n\n/* =========================================================\n   Toolbar\n   ========================================================= */\n.toolbarRow {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n  padding: 16px 24px;\n  border-bottom: 1px solid #EEF0F6;\n}\n\n.searchInput {\n  padding: 9px 14px;\n  border-radius: 10px;\n  border: 1px solid #E5E7EB;\n  font-size: 13.5px;\n  background: #ffffff;\n  min-width: 240px;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n.searchInput:focus {\n  outline: none;\n  border-color: #4c2fb3;\n  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);\n}\n\n.filterSelect {\n  padding: 9px 14px;\n  border-radius: 10px;\n  border: 1px solid #E5E7EB;\n  font-size: 13.5px;\n  background: #ffffff;\n  min-width: 160px;\n  flex-shrink: 0;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n.filterSelect:focus {\n  outline: none;\n  border-color: #4c2fb3;\n  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);\n}\n\n.spacer {\n  flex: 1;\n}\n\n/* =========================================================\n   Status pills\n   ========================================================= */\n.pillBase {\n  display: inline-flex;\n  align-items: center;\n  padding: 3px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n.pillGreen { background: #E9F9EF; color: #16A34A; }\n.pillRed { background: #FDEDED; color: #DC2626; }\n\n.referralChip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: #F5F3FE;\n  color: #4c2fb3;\n  font-weight: 700;\n  font-size: 12px;\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-family: 'Courier New', monospace;\n  cursor: pointer;\n  border: none;\n  transition: background 0.15s ease;\n}\n.referralChip:hover {\n  background: #E7DEFB;\n}\n\n.actionCell {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.sellersChip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: #EEFBF3;\n  color: #16A34A;\n  font-weight: 700;\n  font-size: 12px;\n  padding: 4px 12px;\n  border-radius: 20px;\n  cursor: pointer;\n  border: none;\n  white-space: nowrap;\n  transition: background 0.15s ease;\n}\n.sellersChip:hover {\n  background: #DDF5E6;\n}\n\n/* =========================================================\n   Assigned sellers modal\n   ========================================================= */\n.modalOverlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(17, 12, 46, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 16px;\n}\n\n.modalBox {\n  background: #ffffff;\n  border-radius: 16px;\n  width: 100%;\n  max-width: 460px;\n  max-height: 70vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  box-shadow: 0 20px 60px rgba(17, 12, 46, 0.25);\n}\n\n.modalHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  border-bottom: 1px solid #EEF0F6;\n  font-weight: 700;\n  font-size: 14.5px;\n  color: #1F2430;\n  font-family: 'Sora', 'Inter', sans-serif;\n}\n\n.modalBody {\n  padding: 12px 20px 20px;\n  overflow-y: auto;\n}\n\n.sellerRow {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding: 10px 0;\n  border-bottom: 1px solid #F3F4F6;\n}\n.sellerRow:last-child {\n  border-bottom: none;\n}\n\n.sellerName {\n  font-weight: 700;\n  font-size: 13.5px;\n  color: #1F2430;\n}\n\n.sellerProviderId {\n  font-size: 12px;\n  color: #9CA3AF;\n  font-family: 'Courier New', monospace;\n}\n\n.emptyState {\n  text-align: center;\n  color: #9CA3AF;\n  font-size: 13.5px;\n  padding: 40px 0;\n}\n\n/* =========================================================\n   Mobile card list\n   ========================================================= */\n.mobileCard {\n  border: 1px solid #EEF0F6;\n  border-radius: 14px;\n  background: #ffffff;\n  padding: 16px;\n  margin-bottom: 12px;\n}\n\n.mobileRow {\n  display: flex;\n  gap: 12px;\n  padding: 4px 0;\n  font-size: 13px;\n}\n\n.mobileLabel {\n  min-width: 100px;\n  flex-shrink: 0;\n  color: #6B7280;\n  font-weight: 600;\n}\n\n.mobileValue {\n  color: #1F2430;\n}\n\n.mobileActionRow {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 10px;\n  flex-wrap: wrap;\n}\n\n/* =========================================================\n   Add / Edit form\n   ========================================================= */\n.referralBox {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  background: #F5F3FE;\n  border: 1px solid #E7DEFB;\n  border-radius: 10px;\n  padding: 10px 16px;\n}\n\n.referralCode {\n  font-family: 'Courier New', monospace;\n  font-weight: 700;\n  color: #4c2fb3;\n  font-size: 14px;\n}\n\n.regenerateBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: #ffffff;\n  color: #4c2fb3;\n  border: 1px solid #C9BCF2;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 700;\n  padding: 6px 12px;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n.regenerateBtn:hover {\n  background: #F5F3FE;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageWrap": `FOS_pageWrap__KXJGc`,
	"desktopTable": `FOS_desktopTable__-LA+A`,
	"mobileList": `FOS_mobileList__M0J4N`,
	"toolbarRow": `FOS_toolbarRow__eFOJn`,
	"searchInput": `FOS_searchInput__iaMSm`,
	"filterSelect": `FOS_filterSelect__H0xOF`,
	"spacer": `FOS_spacer__sfD3d`,
	"pillBase": `FOS_pillBase__dO9fy`,
	"pillGreen": `FOS_pillGreen__oJFhU`,
	"pillRed": `FOS_pillRed__agyOh`,
	"referralChip": `FOS_referralChip__WR198`,
	"actionCell": `FOS_actionCell__7LTrQ`,
	"sellersChip": `FOS_sellersChip__G+CwX`,
	"modalOverlay": `FOS_modalOverlay__xsCgT`,
	"modalBox": `FOS_modalBox__iruw5`,
	"modalHeader": `FOS_modalHeader__6z4zf`,
	"modalBody": `FOS_modalBody__4SBqT`,
	"sellerRow": `FOS_sellerRow__MoVyo`,
	"sellerName": `FOS_sellerName__ZYHvN`,
	"sellerProviderId": `FOS_sellerProviderId__AX1vj`,
	"emptyState": `FOS_emptyState__7V5zN`,
	"mobileCard": `FOS_mobileCard__Zf9Vn`,
	"mobileRow": `FOS_mobileRow__t3Ou6`,
	"mobileLabel": `FOS_mobileLabel__Q2ehC`,
	"mobileValue": `FOS_mobileValue__8+ePj`,
	"mobileActionRow": `FOS_mobileActionRow__cycPh`,
	"referralBox": `FOS_referralBox__7L7hj`,
	"referralCode": `FOS_referralCode__jpCXM`,
	"regenerateBtn": `FOS_regenerateBtn__gd8W+`
};
export default ___CSS_LOADER_EXPORT___;
